import React from 'react'
import ResourceContext from '../contexts/ResourceContext'

export default function useResource () {
  return React.useContext(ResourceContext)
}
